
define(
	'NetScore.PDPErrMessage.PDPErrMessage'
,   [
		'NetScore.PDPErrMessage.PDPErrMessage.View'
	]
,   function (
		PDPErrMessageView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			if(layout)
	            {
		            layout.removeChildView('MainActionView');
	            }
			var pdp = container.getComponent('PDP');
			var cart=container.getComponent('Cart');
			// console.log("pdp",pdp);
			// console.log("cart_pdp",cart);
			if(pdp)
             {
                pdp.addChildViews(
                    'ProductDetails.Full.View'
                ,    {
                        'MainActionView': {
                           'NetScore.PDPErrMessage.PDPErrMessage.View' : {
                                childViewIndex: 5
                            ,    childViewConstructor: function()
                                {
                                    return new PDPErrMessageView({
                                        pdp: pdp,
                                        cart:cart
                                    });
                                }
                            }
                        }
                    }
					
			  );
		pdp.addChildViews(pdp.PDP_QUICK_VIEW, {
    'MainActionView': {
        'NetScore.PDPErrMessage.PDPErrMessage.View': {
            childViewIndex: 3,
            childViewConstructor: function childViewConstructor() {
                return new PDPErrMessageView({
                    container: container
                    , pdp: pdp
                    , quickview: 'QuickView'
					, cart:cart
                });
            }
        }
    }
});
			  
		   }
		}
	};
});
